﻿// ============================================================================
// tagsagiKartya.js — a DIGITÁLIS TAGSÁGI KÁRTYA nézete (v165, 2026-10-27; specifikáció: docs/TAGSAGI_KARTYA_SPEC.md).
//
// Tamás elfogadta a demót (tusrajz + adatmezők). Megvalósítási elv: a BAL oldali rajz háttérkép (kartya-rajz-2.webp, dísz: üres alt), a JOBB oldali
// adatmezők ÉLŐ szöveg (fordítható, nagyítható, hosszú névhez igazodik). Az állapot színnel, ikonnal ÉS szöveggel jelenik meg.
// v1-ben csak MEGJELENÍT: a belépést nem ez adja (bejelentkezés + szerveroldali ellenőrzés); QR-kód nincs. Mintaadat: kitalált.
// ============================================================================

import { t } from "./i18n.js";
import { el } from "./dom.js";

/** A kártya állapotai (a szerver adja; hálózati hiba önmagában nem jelent "lejárt"-at). */
export const KARTYA_ALLAPOTOK = ["active", "grace", "suspended", "expired"];

const ALLAPOT_KULCS = { active: "card.statusActive", grace: "card.statusGrace", suspended: "card.statusSuspended", expired: "card.statusExpired" };
const ALLAPOT_IKON = { active: "✓", grace: "!", suspended: "⏸", expired: "✕" };

/** A tagsági szám megjelenítése: LZ-0005237 (7 jegyű, nullákkal kitöltve); érvénytelen szám: kötőjel. */
export function tagsagiSzamSzoveg(n) {
  return Number.isInteger(n) && n > 0 && n <= 9999999 ? "LZ-" + String(n).padStart(7, "0") : "LZ-–––––––";
}

/** A belépés ideje: 2026 · 10 (év · hónap, kétjegyű hónappal). */
export function belepesSzoveg(ev, honap) {
  return Number.isInteger(ev) && Number.isInteger(honap) && honap >= 1 && honap <= 12 ? `${ev} · ${String(honap).padStart(2, "0")}` : "–";
}

/**
 * @param {object} model { uiLang, nickname, number (int), joinedYear, joinedMonth, status: active|grace|suspended|expired }
 * @returns {HTMLElement}
 */
export function renderTagsagiKartya(model) {
  const uiLang = model.uiLang;
  const allapot = KARTYA_ALLAPOTOK.includes(model.status) ? model.status : "expired";
  const kartya = el("section", { class: "member-card", "aria-label": t(uiLang, "card.title") });

  const rajz = el("div", { class: "mc-art", "aria-hidden": "true" });
  rajz.appendChild(el("img", { src: "kartya-rajz-2.webp", alt: "", loading: "lazy", decoding: "async" }));
  kartya.appendChild(rajz);

  const adatok = el("div", { class: "mc-data" });
  const mezo = (cimkeKulcs, ertek, extraOsztaly) => {
    const d = el("div", { class: "mc-field" + (extraOsztaly ? " " + extraOsztaly : "") });
    d.appendChild(el("div", { class: "mc-label", text: t(uiLang, cimkeKulcs) }));
    d.appendChild(el("div", { class: "mc-value", text: ertek }));
    return d;
  };
  adatok.appendChild(mezo("card.nickname", String(model.nickname || "–"), "mc-nickname"));
  adatok.appendChild(mezo("card.number", tagsagiSzamSzoveg(model.number), "mc-number"));
  adatok.appendChild(mezo("card.joined", belepesSzoveg(model.joinedYear, model.joinedMonth)));

  const allapotMezo = el("div", { class: "mc-field" });
  allapotMezo.appendChild(el("div", { class: "mc-label", text: t(uiLang, "card.status") }));
  const jelveny = el("div", { class: "mc-status mc-status-" + allapot, role: "status" });
  jelveny.appendChild(el("span", { class: "mc-status-icon", "aria-hidden": "true", text: ALLAPOT_IKON[allapot] }));
  jelveny.appendChild(el("span", { class: "mc-status-text", text: t(uiLang, ALLAPOT_KULCS[allapot]) }));
  allapotMezo.appendChild(jelveny);
  adatok.appendChild(allapotMezo);

  const lab = el("div", { class: "mc-foot" });
  lab.appendChild(el("span", { class: "mc-kanji", lang: "ja", text: "絆" }));
  lab.appendChild(el("span", { class: "mc-motto", lang: "ja", text: "ともに未来へ" }));
  adatok.appendChild(lab);
  kartya.appendChild(adatok);
  return kartya;
}
